export const PROJET_NAME_BODAC = 'BODAC';
export const PROJET_NAME_AALV = 'AALV';
export const PROJET_NAME_AA = 'AA';
export const PROJET_NAME_PORTAIL_FOURNISSEUR = 'PORTAIL_FOURNISSEUR';
export const PROJET_NAME_PORTAIL_CLIENT = 'PORTAIL_CLIENT';

export const LISTE_PROJET_NAME = [
  { code: PROJET_NAME_BODAC },
  { code: PROJET_NAME_AALV },
  { code: PROJET_NAME_AA },
  { code: PROJET_NAME_PORTAIL_FOURNISSEUR },
  { code: PROJET_NAME_PORTAIL_CLIENT },
];
